<template>
  <!-- eslint-disable max-len -->
  <svg
    width="12.500025"
    height="8.7499971"
    viewBox="0 0 12.500025 8.7499971"
    fill="none"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <path
      d="m 10.6172,0.3203475 c 0.4307,-0.42713 1.129,-0.42713 1.5598,0 0.4307,0.42714 0.4307,1.11966 0,1.5468 l -6.61769,6.56245 c -0.43073,0.4272 -1.12907,0.4272 -1.5598,0 l -3.67647,-3.64579 c -0.43072,-0.42713 -0.43072,-1.11966 0,-1.54679 0.43073,-0.42714 1.12907,-0.42714 1.5598,0 l 2.89657,2.87248 z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'CheckIcon'
}
</script>
